module.exports = __webpack_public_path__ + "static/img/weijianliku.18bbc4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/img/index/weijianliku.png
// module id = 3XCD
// module chunks = 32